import { render } from "./tiposproductorestaurante.vue?vue&type=template&id=b6675eb2&scoped=true"
import script from "./tiposproductorestaurante.vue?vue&type=script&lang=js"
export * from "./tiposproductorestaurante.vue?vue&type=script&lang=js"

import "./tiposproductorestaurante.vue?vue&type=style&index=0&id=b6675eb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6675eb2"]])

export default __exports__